import { Button } from "./Button";
import { NavigateButton } from "./NavigateButton";

Button.Navigate = NavigateButton;

export { Button };
